<template>
  <div id="TranshipmentPreviewData">
    <div v-if="!loading">
      <v-row class="px-5">
        <v-col class="d-flex justify-space-between" cols="12">
          <h6>Dados Gerais</h6>
          <div>
            <router-link :to="`/transhipments/${transhipmentId}/${isCompanyInRouteNumber}`">
              <v-btn color="primary" small> Editar </v-btn>
            </router-link>
          </div>
        </v-col>

        <v-col cols="12" :md="isPersonal ? '8' : '4'">
          <v-text-field
            v-model="generalData.name"
            :label="isPersonal ? 'Nome (Obrigatório)' : 'Razão Social (Obrigatório)'"
            required
            disabled
            autocomplete="off"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" v-if="!isPersonal">
          <v-text-field
            v-model="generalData.tradingName"
            label="Nome Fantasia (Obrigatório)"
            required
            disabled
            autocomplete="off"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" v-show="isPersonal">
          <v-text-field
            v-model="generalData.cpf"
            label="CPF (Obrigatório)"
            required
            disabled
            v-mask="'###.###.###-##'"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" v-show="!isPersonal">
          <v-text-field
            v-model="generalData.cnpj"
            label="CNPJ (Obrigatório)"
            required
            disabled
            v-mask="'##.###.###/####-##'"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="generalData.phone"
            label="Telefone (Obrigatório)"
            required
            disabled
            autocomplete="off"
            v-mask="'(##) ####-####'"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="generalData.cellphone"
            label="Celular (Obrigatório)"
            required
            disabled
            autocomplete="off"
            v-mask="'(##) # ####-####'"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="accessData.email"
            label="Email"
            type="email"
            disabled
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="typeTranshipmentSelected"
            label="Tipo do Transbordo"
            :items="typeTranshipment"
            disabled
          ></v-select>
        </v-col>

        <v-col class="d-flex" cols="12" md="6">
          <v-checkbox
            v-model="isDeliverierTranshipment"
            class="mt-7"
            label="Transbordo Entregador"
            disabled
            hide-details
          />
          <v-tooltip right nudge-top="1">
            <template #activator="{ attrs, on }">
              <v-icon v-bind="attrs" v-on="on" size="24" class="mx-2 mt-5">mdi-information-outline </v-icon>
            </template>
            <span>Além de ser responsável pelo transbordo, também realiza a entregas</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div class="pt-5" v-show="allDataVisible">
          <v-row class="px-5">
            <v-col cols="12">
              <h6>Endereço</h6>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="addressData.cep"
                label="CEP (Obrigatório)"
                required
                disabled
                v-mask="'#####-###'"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="addressData.state"
                label="Estado (Obrigatório)"
                :items="getStates"
                item-text="name"
                item-value="id"
                disabled
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="addressData.cityId"
                label="Cidade (Obrigatório)"
                :items="getCities"
                item-text="name"
                item-value="id"
                disabled
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="addressData.neighborhood"
                label="Bairro (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="addressData.street"
                label="Lougradouro (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                v-model="addressData.number"
                label="Número (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="addressData.complement"
                label="Complemento (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="px-5">
            <v-col cols="12">
              <h6>Dados Bancários</h6>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="bankData.bankName"
                label="Banco (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="bankData.agency"
                label="Agência (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="bankData.account"
                label="Conta (Obrigatório)"
                required
                disabled
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="bankData.cpfOrCnpjHolder"
                label="CPF/CNPJ do titular da conta"
                required
                disabled
                v-mask="initialCpfOrCnpjLength === 11 ? '###.###.###-##' : '##.###.###/####-##'"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="bankData.pixKey" label="PIX" required disabled autocomplete="off"></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <p class="label-radio-group">Títular da conta (Obrigatório)</p>
              <v-radio-group v-model="bankData.isHolder" row disabled>
                <v-radio label="Sim" :value="true"></v-radio>
                <v-radio label="Não" :value="false"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="px-5">
            <v-col cols="12">
              <h6>Dados de Acesso</h6>
            </v-col>
            <v-col cols="12" lg="4" md v-show="isPersonal">
              <v-text-field
                v-model="generalData.cpf"
                label="CPF (Obrigatório)"
                disabled
                readonly
                v-mask="'###.###.###-##'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="4" v-show="!isPersonal">
              <v-text-field
                v-model="generalData.cnpj"
                label="CNPJ (Obrigatório)"
                disabled
                readonly
                v-mask="'##.###.###/####-##'"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-show="isDeliverierTranshipment">
            <v-col cols="12">
              <div class="divider mt-3 mb-5"></div>
            </v-col>
          </v-row>

          <v-row v-show="isDeliverierTranshipment" class="px-5">
            <v-col class="d-flex justify-space-between" cols="12">
              <h6>Dados do Entregador</h6>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="generalData.name" :label="'Nome'" disabled></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="cpfDeliverierTranshipment"
                label="CPF (Obrigatório)"
                disabled
                v-mask="'###.###.###-##'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="cnhNumber"
                label="CNH (Obrigatório)"
                disabled
                v-mask="'#########-##'"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-show="isDeliverierTranshipment" class="px-5">
            <v-col cols="12">
              <h6>Dados do Veículo</h6>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="vehicleData.typeVehicleId"
                label="Tipo de Veículo (Obrigatório)"
                :items="getVehiclesTypes"
                item-text="name"
                item-value="id"
                disabled
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="4" v-if="vehicleData.typeVehicleId === '4a9cebb6-142a-4d9b-a79b-606c5e1250ae'">
              <v-text-field
                v-model="vehicleData.description"
                label="Descrição"
                autocomplete="off"
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field disabled v-model="vehicleData.renavam" label="RENAVAM (Obrigatório)"></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="vehicleData.plate"
                label="Placa (Obrigatório)"
                v-mask="'NNNNNNN'"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
      <div :class="`${allDataVisible ? 'pt-6' : ''} d-flex justify-center`">
        <v-btn color="primary" small @click="allDataVisible = !allDataVisible">
          {{ allDataVisible ? 'Ver menos' : 'Ver mais' }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'TranshipmentPreviewData',
  props: {
    transhipmentId: {
      default: () => null,
      type: String
    }
  },
  data: () => ({
    allDataVisible: false,
    loading: false,
    typeTranshipmentSelected: null,
    isDeliverierTranshipment: false,
    initialCpfOrCnpjLength: null,
    typeTranshipment: [
      {
        text: 'Empresa',
        value: 'enterprise'
      },
      {
        text: 'Pessoal',
        value: 'personal'
      }
    ],
    generalData: {
      name: null,
      tradingName: null,
      cpf: null,
      cnpj: null,
      phone: null,
      cellphone: null
    },
    addressData: {
      cep: null,
      neighborhood: null,
      street: null,
      state: null,
      cityId: null,
      number: null,
      complement: null
    },
    bankData: {
      bankName: null,
      agency: null,
      account: null,
      cpfOrCnpjHolder: null,
      pixKey: null,
      isHolder: true
    },
    accessData: {
      email: null,
      password: null,
      confirmPassword: null
    },
    vehicleData: {
      typeVehicleId: null,
      renavam: null,
      plate: null,
      description: null
    },
    cnhNumber: null,
    cpfDeliverierTranshipment: null
  }),
  created() {
    this.fetchTranshipment();
    this.fetchAllVehiclesTypes();
  },
  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    ...mapGetters('CouriersStore', ['getVehiclesTypes']),
    isPersonal() {
      return this.typeTranshipmentSelected === 'personal';
    },
    isCompanyInRoute() {
      return Boolean(Number(this.$route.params.type));
    },
    isCompanyInRouteNumber() {
      return Number(this.$route.params.type);
    }
  },
  methods: {
    ...mapActions('TranshipmentStore', ['fetchTranshipmentByID'], 'AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('CouriersStore', ['fetchVehiclesTypes']),

    async fetchAllVehiclesTypes() {
      try {
        await this.fetchVehiclesTypes();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchTranshipment() {
      this.loading = true;
      try {
        const data = await this.fetchTranshipmentByID({
          id: this.transhipmentId,
          type: this.isCompanyInRoute
        });

        this.isDeliverierTranshipment = data.isDeliverierTranshipment;

        this.typeTranshipmentSelected = this.isCompanyInRoute ? 'enterprise' : 'personal';

        this.generalData.name = this.isCompanyInRoute ? data.companyName : data.name;

        if (this.isCompanyInRoute) {
          this.generalData.tradingName = data.tradingName;
        }

        this.generalData.cnpj = data.cnpj || null;
        this.generalData.cpf = data.cpf || null;

        this.generalData.phone = data.phones[0];
        this.generalData.cellphone = data.phones[1];

        this.addressData.cep = data.address.cep;
        this.addressData.neighborhood = data.address.neighborhood;
        this.addressData.street = data.address.street;
        this.addressData.cityId = data.address.cityId;
        this.addressData.state = data.address.stateId;

        this.addressData.number = data.address.number;
        this.addressData.complement = data.address.complement;

        this.bankData.bankName = data.bankData.bankName;
        this.bankData.agency = data.bankData.agency;
        this.bankData.account = data.bankData.account;
        this.bankData.cpfOrCnpjHolder = data.bankData.cpfOrCnpjHolder;
        this.initialCpfOrCnpjLength = data.bankData.cpfOrCnpjHolder.length;
        this.bankData.pixKey = data.bankData.pixKey;
        this.bankData.isHolder = data.bankData.isHolder;

        this.accessData.email = data.email;
        this.accessData.password = data.password;
        this.accessData.confirmPassword = data.confirmPassword;

        if (data.vehicle) {
          this.cpfDeliverierTranshipment = data.cpfDeliverierTranshipment;
          this.cnhNumber = data.cnhNumber;
          this.vehicleData.description = data.vehicle.description;
          this.vehicleData.plate = data.vehicle.plate;
          this.vehicleData.renavam = data.vehicle.renavam;
          this.vehicleData.typeVehicleId = data.vehicle.typeVehicleId;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchCitiesByID() {
      try {
        await this.fetchCities(this.addressData.state);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style></style>
